export function TomorrowIcon({
  width = 24,
  height = 24,
  className = '',
}: {
  width?: number;
  height?: number;
  className?: string;
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_315_34574)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.42857 3.42815C2.4818 3.42815 1.71429 4.19566 1.71429 5.14244V20.571C1.71429 21.5178 2.4818 22.2853 3.42857 22.2853H20.5714C21.5182 22.2853 22.2857 21.5178 22.2857 20.571V5.14244C22.2857 4.19566 21.5182 3.42815 20.5714 3.42815H3.42857ZM0 5.14244C0 3.24889 1.53502 1.71387 3.42857 1.71387H20.5714C22.465 1.71387 24 3.24889 24 5.14244V20.571C24 22.4646 22.465 23.9996 20.5714 23.9996H3.42857C1.53502 23.9996 0 22.4646 0 20.571V5.14244Z"
          fill="#8AC200"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.1423 0C5.61569 0 5.99944 0.383756 5.99944 0.857143V2.57143C5.99944 3.04482 5.61569 3.42857 5.1423 3.42857C4.66891 3.42857 4.28516 3.04482 4.28516 2.57143V0.857143C4.28516 0.383756 4.66891 0 5.1423 0Z"
          fill="#8AC200"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.8571 0C19.3305 0 19.7143 0.383756 19.7143 0.857143V2.57143C19.7143 3.04482 19.3305 3.42857 18.8571 3.42857C18.3838 3.42857 18 3.04482 18 2.57143V0.857143C18 0.383756 18.3838 0 18.8571 0Z"
          fill="#8AC200"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 6.85714C0 6.38376 0.383756 6 0.857143 6H23.1429C23.6162 6 24 6.38376 24 6.85714C24 7.33053 23.6162 7.71429 23.1429 7.71429H0.857143C0.383756 7.71429 0 7.33053 0 6.85714Z"
          fill="#8AC200"
        />
        <path
          d="M19.6149 14.8287C19.7711 14.6725 19.7711 14.4193 19.6149 14.2631L17.0693 11.7175C16.9131 11.5613 16.6598 11.5613 16.5036 11.7175C16.3474 11.8737 16.3474 12.1269 16.5036 12.2832L18.7663 14.5459L16.5036 16.8086C16.3474 16.9648 16.3474 17.2181 16.5036 17.3743C16.6598 17.5305 16.9131 17.5305 17.0693 17.3743L19.6149 14.8287ZM5.33203 14.5459V14.9459H19.332V14.5459V14.1459H5.33203V14.5459Z"
          fill="#8AC200"
        />
      </g>
      <defs>
        <clipPath id="clip0_315_34574">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default TomorrowIcon;
